// @core/api/endpoints/workflow/list_signed_decisions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSignedDecisionsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List signed decisions
 * Returns the tamper-evident record of who decided what and when. Append-only and retained independently of the runs it describes.
 */
export async function ListSignedDecisions(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSignedDecisionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/signed-decisions`;
  const requestOptions = options;
  return client.get<ListSignedDecisionsResponse>(requestPath, { ...requestOptions, params });
}
